<template>
  <div class="article">
    <skeleton
      :count="20"
      template="lines"
      default-height="70vh"
      :content-ready="!asyncStatus.asyncDataLoading">
      <div class="article-content">
        <div
          v-for="(section, index) of article.sections"
          v-if="article.sections"
          :id="`article-section-${index}`"
          class="section margin-max-bottom">
          <h3>{{ section.title }}</h3>
          <content-blocks :content="section.content"></content-blocks>
        </div>
      </div>
    </skeleton>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { reactive, computed } from "vue";

export default {
  components: {},
  layout: {
    component: "default",
    params: reactive({
      title: "core.article.genericTitle",
      //   containerClass: "margin-remove-vertical",
    }),
  },
  middleware: {},
  props: {
    alias: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: {
    title: "core.article.genericBrowserTitle",
  },
  data() {
    return {
      article: false,
      hashHandled: false,
      asyncData: {
        article: {
          target: "content/article/" + this.alias,
          data: {},
          options: {
            dataMutator(input, result) {
              if (input.item) {
                return input.item;
              }
              return false;
            },
            errorHandler: "404",
          },
        },
      },
    };
  },
  computed: {},
  watch: {
    async article(newVal) {
      if (!newVal) {
        return;
      }

      let layoutConf = this[config.layoutAccessorKey]();
      if (newVal.title) {
        layoutConf.params.title = newVal.title;
      }

      if (newVal.subTitle) {
        layoutConf.params.subTitle = newVal.subTitle;
      }

      if (newVal.metaTitle) {
        this.meta.title = newVal.metaTitle;
      }
    },
    $route: {
      handler(newVal) {
        this.handleHash();
      },
      immediate: true,
    },
  },

  methods: {
    async scrollToElement(el) {
      if (utilities.isSSR()) {
        return true;
      }
      const offset = -120;
      const y = el.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    },
    async scrollToElement(hash) {
      if (utilities.isSSR()) {
        return true;
      }

      if (!hash) {
        return true;
      }
      await utilities.wait(300);

      await utilities.waitUntil(async () => {
        return !!this.article;
      });

      try {
        let anchor = document.querySelector(hash);
        this.scrollToElement(anchor);
      } catch (e) {
        setTimeout(() => {
          let anchor = document.querySelector(hash);
          this.scrollToElement(anchor);
        }, 300);
      }
    },
    async handleHash() {
      if (!this.$route.hash) {
        return true;
      }

      await utilities.waitUntil(async () => !!this.article, 100);

      this.scrollToSection(this.$route.hash);
    },
  },
};
</script>

<style lang="scss" scoped></style>
